// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_27wU3oj","container":"_3fR1hJ4","title":"_10jm6IY","gamesInnerContainer":"_8VjCZ6v"};